// 罗马尼亚语
export const GUIDES = [
  { name: 'guide-overview', title: 'Prezentare generală a funcțiilor', groupIndex: 0 },
  { name: 'guide-account', title: 'Despre cont', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Despre vehicul', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Cum se configurează tabloul de bord', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Cum se configurează vehiculul', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Cum să navigați pentru a găsi vehiculul', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Cum să utilizați navigația', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Despre istoricul cursei', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Cum să efectuați o autoinspecție a vehiculului', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Cum să faci setările generale ale aplicației', groupIndex: 3 },
  { name: 'guide-notice', title: 'Cum să vizualizați și să setați notificarea mesajului', groupIndex: 3 },
  { name: 'guide-about', title: 'Despre APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'In asteptarea',
  1: 'Niciun răspuns',
  2: 'Răspuns',
  3: 'în comunicare',
  4: 'contramăsuri',
  5: 'rezolvat',
};

export const FEEDBACK_TYPES = {
  1: 'Feedback',
  2: 'Răspunde',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
